import { HoneycombStyleSystemProps } from '../../../theming/types/HoneycombStyleSystem';
import { filterProps } from '../../../theming';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractStyleSystemProps<T extends Record<string, any>>(
    others: HoneycombStyleSystemProps & T
): { styleSystemProps: HoneycombStyleSystemProps; rest: T } {
    const {
        m,
        mx,
        my,
        mt,
        mb,
        ml,
        mr,
        p,
        px,
        py,
        pt,
        pb,
        pl,
        pr,
        w,
        miw,
        maw,
        h,
        mih,
        mah,
        bg,
        c,
        fill,
        opacity,
        pos,
        top,
        left,
        bottom,
        right,
        inset,
        display,
        flex,
        flexGrow,
        flexShrink,
        flexBasis,
        alignContent,
        alignItems,
        alignSelf,
        flexDirection,
        justifyContent,
        flexWrap,
        order,
        gap,
        overflow,
        overflowX,
        overflowY,
        zIndex,
        ta,
        tal,
        va,
        fontSize,
        fw,
        b,
        bs,
        bc,
        bw,
        btw,
        bbw,
        blw,
        brw,
        br,
        btr,
        bbr,
        btlr,
        btrr,
        bblr,
        bbrr,
        transition,
        transform,
        backgroundImage,
        backgroundSize,
        backgroundRepeat,
        backgroundPosition,
        objectFit,
        aspectRatio,
        outline,
        textShadow,
        boxShadow,
        pointerEvents,
        filter,
        ...rest
    } = others;

    const styleSystemProps = filterProps({
        m,
        mx,
        my,
        mt,
        mb,
        ml,
        mr,
        p,
        px,
        py,
        pt,
        pb,
        pl,
        pr,
        w,
        miw,
        maw,
        h,
        mih,
        mah,
        bg,
        c,
        fill,
        opacity,
        pos,
        top,
        left,
        bottom,
        right,
        inset,
        display,
        flex,
        flexGrow,
        flexShrink,
        flexBasis,
        alignContent,
        alignItems,
        alignSelf,
        flexDirection,
        justifyContent,
        flexWrap,
        order,
        gap,
        overflow,
        overflowX,
        overflowY,
        zIndex,
        ta,
        tal,
        va,
        fontSize,
        fw,
        b,
        bs,
        bc,
        bw,
        btw,
        bbw,
        blw,
        brw,
        br,
        btr,
        bbr,
        btlr,
        btrr,
        bblr,
        bbrr,
        transition,
        transform,
        backgroundImage,
        backgroundSize,
        backgroundRepeat,
        backgroundPosition,
        objectFit,
        aspectRatio,
        outline,
        textShadow,
        boxShadow,
        pointerEvents,
        filter,
    });

    return { styleSystemProps, rest: rest as unknown as T };
}
